import { useEffect, useRef, useState } from 'react';

const useShowLoader = isLoading => {
  const startTimeRef = useRef(null);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    let startTime = startTimeRef.current;
    let limitTime = 1500;

    if (isLoading) {
      startTimeRef.current = performance.now(); // Marca inicio
      setShowLoader(true);
    } else {
      const endTime = performance.now();
      const duration = endTime - startTime;

      if (duration < limitTime) {
        const remaining = limitTime - duration;
        setTimeout(() => setShowLoader(false), remaining);
      } else {
        setShowLoader(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return { showLoader };
};

export default useShowLoader;
